import React from 'react';
import { render } from 'react-dom';

import FaqSection from './components/FaqSection.jsx';

export default element => {
  const config = JSON.parse(document.querySelector(element.dataset.jsModuleConfig).innerHTML);

  render(<FaqSection data={config} />, element);
};
